// Gesprek voorvullen vanuit een website-aanvraag of lead. Portering van het losse intake-prototype (TypeScript); logica ongewijzigd.
import { LEEG } from "./calc";
const MAX = 2000;
const knip = (x) => (x ?? "").toString().trim().slice(0, MAX);
const samen = (delen, scheiding) => delen.map(knip).filter(Boolean).join(scheiding);
export function vanAanvraag(a) {
    return {
        ...LEEG,
        bedrijf: knip(a.bedrijf),
        contact: knip(a.naam),
        contactinfo: samen([a.email, a.telefoon], " · "),
        branche: knip(a.soort),
        aanvraag: samen([
            a.omschrijving,
            a.project_type ? `Type: ${knip(a.project_type)}` : "",
            a.budget ? `Budget in aanvraag: ${knip(a.budget)}` : "",
            a.plaats ? `Plaats: ${knip(a.plaats)}` : "",
        ], "\n"),
        situatie: knip(a.huidige_situatie),
        opleverdatum: knip(a.startmoment),
    };
}
export function vanLead(l) {
    return {
        ...LEEG,
        bedrijf: knip(l.company),
        contact: knip(l.name),
        contactinfo: samen([l.email, l.phone], " · "),
        branche: knip(l.industry),
        aanvraag: samen([l.interest, l.notes], "\n"),
    };
}
